import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <div className="space-sep">
                                                <p>Individuals can be persuaded to go that extra mile and do
                                                    something for nothing. However,
                                                    encouraging this in others can be tricky. This tool is
                                                    about <span
                                                        className="green"><strong>how to direct people</strong></span> and
                                                    will introduce you to the concept of 'discretionary effort'
                                                    which is the amount of effort we are willing to put into the
                                                    work we do, over and above what is required. This is closely
                                                    linked with an individual's engagement and this tool will
                                                    help you to explore your style and how you can adapt this to
                                                    encourage these behaviours in others. </p></div>


                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>UNDERSTANDING DISCRETIONARY EFFORT
                                            </div>
                                            <div className="border_subtitle">Directing people to meet
                                                organisational goals
                                            </div>
                                            <p>An organisation is only as good as its people. True - but it's
                                                more about how managers direct and
                                                maximise the potential of those people. Getting people to
                                                achieve organisational goals is one thing, but wouldn't it feel
                                                good - and profitable - if this and more was achieved because
                                                everyone felt motivated to give just a little extra? So, here
                                                we'll take a slightly different perspective from most other
                                                advice offered to managers. This is about the difference
                                                'discretionary effort' and
                                                'employee engagement' make to what and how things are
                                                achieved. </p>
                                            <div className="border_subtitle">What is discretionary
                                                effort?<sup><a className="superscripttext supLinesapce"
                                                               href="further_info.php?course=300">3</a></sup>
                                            </div>
                                            <p>It's when people choose to contribute more than is required to
                                                meet minimum standards of
                                                performance. Discretionary effort (DE) is about giving more than
                                                is itemised on a job description, or demanded by specific
                                                targets. It's not necessarily about working longer hours but
                                                includes,
                                                for example: </p>

                                            <ul className="greenbullet-list">
                                                <li>Helping a busy colleague with their workload</li>
                                                <li>Volunteering to run or take part in activities either within
                                                    the organisation or on its behalf
                                                </li>
                                                <li> Suggesting or developing improvements and alternatives to
                                                    existing practices and products.
                                                </li>
                                            </ul>
                                            <br/>
                                            <div className="border_subtitle bullethead">How is discretionary
                                                effort going to help me?
                                            </div>
                                            <p>Research suggests that in an environment where DE is
                                                encouraged and recognised, employees
                                                are not only more efficient and productive, but demonstrate
                                                greater 'engagement'. These two,
                                                interdependent characteristics are what drive the most
                                                successful organisations. In other words,
                                                when people are made to feel they belong, with value and
                                                potential beyond their mere function,
                                                they give more. </p>
                                            <p>If that sounds like the kind of white noise you'd expect from
                                                a bunch of psychologists who aren't
                                                sandwiched, like you, between a remote executive and all the
                                                cynical, clock-watching wage slaves
                                                you manage, then here are some stats you can bite on: </p>
                                            <p>Results from the Gallup Workforce Studies<sup><a
                                                className="superscripttext supLinesapce"
                                                href="further_info.php?course=300">4</a></sup> revealed,
                                                during a fixed time period, that the bottom
                                                line in those organisations whose employees demonstrated the
                                                two dynamics we've been discussing was improved as a result
                                                of increasing operating and net profit margins. Those
                                                without it showed a decline in these financial indicators
                                                during the same period. More specifically,
                                                organisations that adopted a deliberately inclusive approach
                                                to encourage DE experienced: </p>
                                            <ul className="greenbullet-list">
                                                <li>Greater customer satisfaction/loyalty + 39%</li>
                                                <li>Increased productivity + 22%</li>
                                                <li>Higher profitability + 27%</li>
                                                <li>Lower turnover - 22%.
                                                </li>
                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}